var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('emp-select',_vm._g({attrs:{"disabled":_vm.disabled,"fieldClass":_vm.fieldClass,"label":_vm.label,"labelClass":_vm.labelClass,"options":_vm.roleOptions,"placeholder":_vm.placeholder,"value":_vm.value}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }